import { render, staticRenderFns } from "./event-detail-status.vue?vue&type=template&id=d785b93c&scoped=true&"
import script from "./event-detail-status.vue?vue&type=script&lang=js&"
export * from "./event-detail-status.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-status.vue?vue&type=style&index=0&id=d785b93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d785b93c",
  null
  
)

export default component.exports